<div class="tech-menumain" @filterAnimation *ngIf="this.commonService.menuOpen">
  <div class="logo-element" routerLink="/portfolios">
    <img src="./assets/img/{{ customTheme }}/TRLogoWhite.png" class="pointer" />
  </div>
  <ul>
    <li
      class="tech-sidenav-pages pointer"
      *ngFor="let item of pages"
      matTooltip="{{ item.label | translate }}"
      matTooltipPosition="before"
      routerLink="{{ item.url }}"
      routerLinkActive="active"
      (click)="commonService.colapseMenu()"
    >
      <fa-icon [icon]="item.icon"></fa-icon>
    </li>
  </ul>
  <div class="tech-spacer"></div>
  <button
    mat-menu-item
    class="btn-logout"
    (click)="commonService.goLogout()"
    matTooltip="{{ 'k000257' | translate }}"
    matTooltipPosition="before"
  >
    <fa-icon icon="sign-out-alt"></fa-icon>
  </button>
</div>

<div
  class="menuMovil"
  *ngIf="
    this.commonService.isMovilSource.getValue() &&
    this.commonService.showMenuSource.getValue()
  "
>
  <ul class="flex-container-nowrap flex-space-around">
    <li
      class="flex-item-grow float-left pointer"
      *ngFor="let item of pages"
      matTooltip="{{ item.label | translate }}"
      matTooltipPosition="above"
      routerLink="{{ item.url }}"
      routerLinkActive="active"
    >
      <fa-icon [icon]="item.icon"></fa-icon>
    </li>
  </ul>
</div>
